import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import CardHeader from "components/Card/CardHeader";
import { useTranslation } from "react-i18next";

function ListPageCardUserHeader({ userData, ...rest }) {
    const textColor = useColorModeValue("gray.700", "white");
    const { t } = useTranslation();

    return (
        <CardHeader px="22px" mb="24px" {...rest}>
            <Flex gap="1" direction="column">
                {userData?.login && (
                    <Text color={textColor} fontSize="sm">
                        <strong>{t("settings.user.list.table.header.login")}:</strong> {userData.login}
                    </Text>
                )}
                {userData?.pessoa?.nome && (
                    <Text color={textColor} fontSize="sm">
                        <strong>{t("settings.person.list.table.header.name")}:</strong> {userData.pessoa.nome}
                    </Text>
                )}
                {userData?.pessoa?.email && (
                    <Text color={textColor} fontSize="sm">
                        <strong>{t("settings.person.list.table.header.email")}:</strong> {userData.pessoa.email}
                    </Text>
                )}
                {userData?.pessoa?.telefone && (
                    <Text color={textColor} fontSize="sm">
                        <strong>{t("settings.person.list.table.header.telephone")}:</strong> {userData.pessoa.telefone}
                    </Text>
                )}
            </Flex>
        </CardHeader>
    );
}

export default ListPageCardUserHeader;
